module.exports = __webpack_public_path__ + "img/ranking-top-bg.ce14af6d.png";